module.exports = ".wrapper {\n  width: auto;\n  max-width: 100%;\n  height: 100%;\n  position: relative; }\n"